export const AMAZON_URL = "https://a.co/d/0esTALay";
export const AMAZON_AUTHOR_URL = "https://www.amazon.ca/Michael-B-Ford/e/B0FWZ41NFY";
export const SERIES_URL = "https://www.amazon.ca/dp/B0FR2BBRL3";
export const BOOK2_TITLE = "Aurora Unbound";
export const BOOK2_DATE = "September 15, 2026";
export const BOOK2_COVER =
  "https://m.media-amazon.com/images/I/711+UMsu5yL._SL1200_.jpg";
export const BOOK2_COVER_BACK = "/aurora-unbound-back.jpg";
export const BOOK2_ISBN = "979-8194725762";
export const BOOK2_PAGES = "552 pages";
export const BOOK2_TAGLINE = "The storm has broken. Now the whole country will feel it.";
export const BOOK2_EARLY_REVIEW = "A bold, bigger, electric sequel full of heart and danger.";
export const BOOK2_ASIN = "B0HHWPQ374";
export const BOOK2_URL = "https://www.amazon.ca/dp/B0HHWPQ374";
export const BOOK2_PRICE = "$29.99 CAD";
export const ISBN = "979-8262108763";
export const ASIN_PAPERBACK = "B0FR2B17GG";
export const ASIN_HARDCOVER = "B0FRGBPX2B";
export const URL_PAPERBACK = "https://www.amazon.ca/dp/B0FR2B17GG";
export const URL_HARDCOVER = "https://www.amazon.ca/dp/B0FRGBPX2B";
export const COVER_URL = "https://m.media-amazon.com/images/I/619aeeqMVKL._SL1200_.jpg";
export const AURORA_BG =
  "https://images.unsplash.com/photo-1776854634319-e853ea3aa6af?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";
export const BOOK_TITLE = "Northern Lights Rising";
export const SERIES_NAME = "The Aurora Chronicles";
export const AUTHOR_NAME = "Michael B. Ford";
